import { setHours } from "date-fns";
import { APIActions } from "../../api/actions";
import { clearCache } from "../../api/cache";

export const formatExpenseToApi = ({
  expenseData = {},
  routes,
  receipts,
  isRoute,
}) => {
  const {
    notes,
    category,
    date,
    amount,
    project,
    travel,
    payment,
    currency,
    place,
    dailyNumber,
    dailyRate,
    odometer,
    liters,
    vehicle,
    fuelType,
    fullTank,
    sendToApproval,
    routePolicy,
    roundTrip,
    distance,
    group,

    //custom fields
    customFields,
  } = expenseData;
  let formattedData = {
    type: isRoute ? "route" : "regular",
    notes,
    currency,
    category: category?._id || null,
    group: group?._id || null,
    project: project?._id || null,
    travel: travel?._id || null,
    date: setHours(new Date(date), 3),
    amount: parseFloat(amount) || 0,
    payment: payment?._id
      ? {
          id: payment?._id,
          isAdvance: payment?.type === "advance" || payment?.isAdvance,
        }
      : null,
    placeId: place?.id || null,
    categoryProperties: Boolean(category)
      ? category?.type === "accommodation"
        ? {
            dailyNumber,
            dailyRate,
          }
        : category?.type === "fuel"
        ? {
            odometer: parseFloat(odometer),
            liters: parseFloat(liters),
            vehicle: vehicle?._id || undefined,
            fuelType,
            fullTank,
          }
        : {}
      : null,
    receipts,
    sendToApproval: Boolean(sendToApproval),
    customFields,
  };
  if (!Array.isArray(receipts)) {
    delete formattedData.receipts;
  }
  if (isRoute && Array.isArray(routes) && routes?.length) {
    formattedData.from = routes[0] || null;
    formattedData.to = routes[routes.length - 1] || null;
    formattedData.waypoints = routes.slice(1, -1) || null;
    formattedData.distance = parseFloat(distance || 0);
    formattedData.roundTrip = roundTrip;
  }
  if (isRoute && routePolicy?._id) {
    formattedData.routePolicyId = routePolicy?._id || null;
  }
  return formattedData;
};

export function extractCustomFieldValues(fields) {
  const result = {};
  for (const id in fields) {
    result[id] = fields[id].value;
  }
  return result;
}

export const formatExpenseFromApi = (expenseData = {}) => {
  const route = expenseData?.route || {};
  // Para rotas predefinidas, sintetizamos preDefinedRoute em routePolicy
  // para que `isFixedRoutePolicy` reconheça o tipo no carregamento inicial
  // (a API retorna apenas a flag `isPredefined` na raiz do route).
  const isPredefined = route?.isPredefined === true;
  // Em rotas predefinidas o valor devolvido pela API já está com o "ida e
  // volta" aplicado. Guardamos sempre o valor base (somente ida), para que a
  // tela consiga recalcular o total ao marcar/desmarcar o ida e volta.
  const preDefinedBaseAmount = isPredefined
    ? (Number(route?.rate ?? expenseData?.originalAmount?.amount) || 0) /
      (route?.roundTrip ? 2 : 1)
    : 0;
  return {
    ...expenseData,
    currency: expenseData?.originalAmount?.currency,
    amount: expenseData?.originalAmount?.amount || "",
    ...expenseData?.categoryProperties,
    ...route,
    routePolicy: {
      _id: route?.policyId,
      name: route?.policyName,
      currentRate: isPredefined ? preDefinedBaseAmount : route?.rate,
      ...(isPredefined
        ? {
            preDefinedRoute: {
              point1: route?.from || "",
              point2: route?.to || "",
              amount: preDefinedBaseAmount,
            },
          }
        : {}),
    },
    originalCustomFields: expenseData?.customFields || {},
    customFields: expenseData?.customFields
      ? extractCustomFieldValues(expenseData?.customFields || {})
      : {},
  };
};

export const saveExpense = async ({
  sendToApproval = false,
  values = {},
  receipts = [],
  routes,
  expenseId,
  signal,
  role,
  isRoute,
}) => {
  try {
    const responseData = await APIActions.expenses.update({
      expenseId,
      role,
      signal,
      changes: formatExpenseToApi({
        expenseData: {
          ...values,
          sendToApproval,
        },
        receipts,
        routes,
        isRoute,
      }),
    });
    clearCache("/advances");
    return {
      ok: true,
      data: responseData,
      error: null,
    };
  } catch (error) {
    return {
      ok: false,
      data: null,
      error,
    };
  }
};
